/* unplugin-vue-components disabled */import { render } from "./company-info.vue?vue&type=template&id=0382ad39&scoped=true"
import script from "./company-info.vue?vue&type=script&lang=js"
export * from "./company-info.vue?vue&type=script&lang=js"

import "./company-info.vue?vue&type=style&index=0&id=0382ad39&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0382ad39"],['__file',"src/components/cards-v2/company/company-info.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0382ad39"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0382ad39', __exports__)) {
    api.reload('0382ad39', __exports__)
  }
  
  module.hot.accept("./company-info.vue?vue&type=template&id=0382ad39&scoped=true", () => {
    api.rerender('0382ad39', render)
  })

}


export default __exports__